import { IPurchaseProduct } from '../../model/types/IPurchaseProduct';

interface IParams {
  item: IPurchaseProduct;
}

export const getProductsInfo = ({ item }: IParams) => {
  let info;

  if (item.wb_product && item.wb_product_info) info = item.wb_product_info;
  else if (item.ozon_product && item.ozon_product_info)
    info = item.ozon_product_info;
  else info = item.info;

  return info;
};
